/* Product-page hero carousel: arrows, keyboard arrows and touch swipe.
   Slide 1 (the landing's hero photo) is always rendered so the frame never changes size.
   Other slides stay hidden until needed, so their photos only download when a shopper browses. */
(() => {
  const motionOn = () => document.documentElement.classList.contains('mv-motion'); // set in the page head

  function init(root) {
    if (root.dataset.ivcReady) return;
    const slides = [...root.querySelectorAll(':scope > .ivc-slide')];
    if (slides.length < 2) return;
    root.dataset.ivcReady = 'true';
    let current = 0;
    const at = n => (n + slides.length) % slides.length;
    const warm = n => { const img = slides[at(n)].querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; };
    slides.forEach((slide, n) => slide.setAttribute('aria-label', `${n + 1} of ${slides.length}`));

    async function go(n) {
      n = at(n);
      if (n === current) return;
      current = n;
      const to = slides[n];
      to.hidden = false;
      const img = to.querySelector('img');
      if (img && !img.complete) { img.loading = 'eager'; try { await img.decode(); } catch {} }
      if (current !== n) return; // a faster click already moved on
      requestAnimationFrame(() => slides.forEach(slide => {
        const on = slide === to;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
      }));
      // Once the fade is over, stop painting the photos that are no longer shown (slide 1 always stays).
      setTimeout(() => slides.forEach((slide, k) => { if (k && k !== current && !slide.classList.contains('is-active')) slide.hidden = true; }), motionOn() ? 500 : 0);
      warm(n + 1); warm(n - 1);
    }

    root.querySelector('.ivc-prev')?.addEventListener('click', () => go(current - 1));
    root.querySelector('.ivc-next')?.addEventListener('click', () => go(current + 1));
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    let x0 = null, y0 = 0;
    root.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') { x0 = e.clientX; y0 = e.clientY; } });
    root.addEventListener('pointerup', e => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(current + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('pointercancel', () => { x0 = null; });

    // Fetch the second photo only once the page has finished loading and the browser is idle, and never on a
    // slow or metered connection: during load that bandwidth belongs to the hero photo.
    const link = navigator.connection || {};
    const prefetchNext = () => {
      if (link.saveData || /(^|-)2g$/.test(link.effectiveType || '')) return;
      (window.requestIdleCallback || (fn => setTimeout(fn, 1500)))(() => warm(1), { timeout: 4000 });
    };
    if (document.readyState === 'complete') prefetchNext();
    else addEventListener('load', prefetchNext, { once: true });
  }

  const run = () => document.querySelectorAll('[data-ivc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
